export default function Tour() {
  return {}
}
